<app-dialog
	modalTitle="Políticas"
	titleButton="Salvar"
	secTitleButton="Cancelar"
	[secButton]="true"
	[hideFooter]="false"
	[noMargins]="true"
	[disabled]="form.invalid"
	(dialogClose)="closeModal()"
	(dialogSave)="onContinue()"
>
	<ng-container *ngIf="loading">
		<div class="d-f jc-c ai-c w-100 mt-giant">
			<mat-spinner diameter="20"></mat-spinner>
		</div>
	</ng-container>
	<ng-container *ngIf="!loading && healthPolicies && dentalPolicies">
		<div class="w-100 h-100 container" [formGroup]="form">
			<div class="d-f mt-xxxs ml-xxxs line">
				<mat-form-field
					class="mr-xxxs col-1"
					title="Política de saúde"
					appearance="outline"
				>
					<mat-label>Política de saúde</mat-label>
					<mat-select formControlName="health_policy">
						<mat-option *ngFor="let pol of healthPolicies" [value]="pol?.id">
							{{ pol?.name }}
						</mat-option>
					</mat-select>
					<mat-error *ngIf="form.get('health_policy')?.hasError('required')">
						Campo obrigatório
					</mat-error>
				</mat-form-field>
			</div>
			<div class="d-f mt-xxxs ml-xxxs line">
				<mat-form-field
					class="mr-xxxs col-1"
					title="Política dental"
					appearance="outline"
				>
					<mat-label>Política dental</mat-label>
					<mat-select formControlName="dental_policy">
						<mat-option *ngFor="let pol of dentalPolicies" [value]="pol?.id">
							{{ pol?.name }}
						</mat-option>
					</mat-select>
					<mat-error *ngIf="form.get('dental_policy')?.hasError('required')">
						Campo obrigatório
					</mat-error>
				</mat-form-field>
			</div>
		</div>
	</ng-container>
</app-dialog>
